import { CheckCircleOutlined, HomeOutlined } from "@ant-design/icons";
import { Button, Card, Typography } from "antd";
import { Link } from "react-router";

const { Title, Paragraph } = Typography;

export default function SuccessPayment() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-50 flex items-center justify-center p-4">
      <Card className="max-w-2xl w-full shadow-2xl border-0 rounded-2xl overflow-hidden">
        <div className="text-center py-8">
          <div className="mb-6">
            <CheckCircleOutlined className="text-green-600 text-8xl animate-bounce" />
          </div>

          <Title level={2} className="6ext-green-600 mb-2">
            Payment Successful!
          </Title>

          <Paragraph className="text-gray-600 text-lg mb-8">
            Your transaction has been completed successfully
          </Paragraph>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/">
              <Button type="primary" size="middle" icon={<HomeOutlined />}>
                Back to Home
              </Button>
            </Link>
          </div>
        </div>
      </Card>
    </div>
  );
}
